module.exports = __webpack_public_path__ + "static/media/02.2a30232a.jpg";